import { ArticleHeading1, ArticleParagraph1, Button, MaskedInput, Modal, Select, TDeviceType } from '@cian/ui-kit';
import cn from 'classnames';
import { useEffect } from 'react';
import { DealsLeadFormResultModal } from 'shared/components/DealsLeadFormResultModal';
import { DealsLegalCheck } from 'shared/components/DealsLegalCheck';
import { useDealsLeadFormFields } from 'shared/hooks/useDealsLeadFormFields';
import type { IDealsLeadFormRegionOption } from 'shared/types/dealsForm';
import { caOpenCpdPopupForm } from 'shared/utils/analytics/cpdDeals/trackingCpdDeals';

import * as s from './styles.css';

interface IDealModalFormProps {
  open: boolean;
  device: TDeviceType;
  onOpenChange(): void;
  title: string;
  subtitle: string;
  regionOptions: IDealsLeadFormRegionOption[];
  postId: number;
}

export const DealModalForm: React.FC<IDealModalFormProps> = ({
  open,
  device,
  onOpenChange,
  title,
  subtitle,
  regionOptions,
}) => {
  const isTablet = device === 'tablet';
  const { phoneProps, selectProps, isAgreementChecked, handleAgreementChange, resultModalProps, submitButtonProps } =
    useDealsLeadFormFields({
      onAfterSubmit: onOpenChange,
      source: 'magazineBanner',
      isTablet,
    });

  useEffect(() => {
    if (!open) {
      return;
    }

    caOpenCpdPopupForm();
  }, [open]);

  return (
    <>
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        width={device === 'phone' ? undefined : 'max-content'}
        body={
          <div className={cn(s['container'], s[device])}>
            <div className={s['text-block']}>
              <ArticleHeading1>{title}</ArticleHeading1>
              <ArticleParagraph1>{subtitle}</ArticleParagraph1>
            </div>
            <div className={s['form']}>
              <MaskedInput {...phoneProps} />
              <Select {...selectProps} options={regionOptions} />
              <div className={s['button-wrapper']}>
                <Button {...submitButtonProps} fullWidth size="M">
                  Отправить заявку
                </Button>
              </div>
            </div>
            <DealsLegalCheck
              checked={isAgreementChecked}
              onCheckedChange={handleAgreementChange}
              withMarketingAgreement
            />
          </div>
        }
      />
      <DealsLeadFormResultModal {...resultModalProps} />
    </>
  );
};
